import { Link } from 'react-router-dom';

// Persistent rights reminder + legal links. Sits at the bottom of every
// authenticated page and on the studio surface.
export function Footer({ compact = false }: { compact?: boolean }) {
  return (
    <footer
      style={{
        textAlign: 'center',
        color: 'var(--text-dim)',
        fontSize: 11,
        padding: compact ? '12px 16px 8px' : '24px 16px 16px',
        lineHeight: 1.6,
      }}
    >
      <div>
        By using Riffloop, you agree you have rights to the audio you process.{' '}
        <Link to="/tos" style={{ color: 'var(--text-dim)', textDecoration: 'underline' }}>
          See Terms
        </Link>
        .
      </div>
      {!compact && (
        <div style={{ marginTop: 6 }}>
          <Link to="/tos" style={{ color: 'var(--text-dim)' }}>
            Terms
          </Link>{' '}
          ·{' '}
          <Link to="/privacy" style={{ color: 'var(--text-dim)' }}>
            Privacy
          </Link>{' '}
          ·{' '}
          <a
            href="mailto:riffloopapp@gmail.com"
            style={{ color: 'var(--text-dim)' }}
          >
            DMCA
          </a>
        </div>
      )}
    </footer>
  );
}
